/* import React, { useState } from "react";

function ForcePasswordChangeForm({ username, onPasswordChanged, setSnackbar, theme }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "newPassword") setNewPassword(value);
    if (name === "confirmPassword") setConfirmPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Completa ambos campos.",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Las contraseñas no coinciden.",
      });
      return;
    }
    setLoading(true);
    try {
      // Aquí deberías llamar al servicio de cambio de contraseña
      // await changePasswordService({ username, newPassword });
      setSnackbar({
        severity: "success",
        visible: true,
        message: "Contraseña cambiada correctamente.",
      });
      setLoading(false);
      onPasswordChanged();
    } catch (err) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Error al cambiar la contraseña.",
      });
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col h-[28rem] justify-around m-4"
    >
      <div className="space-y-6 pb-5">
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Usuario
          </label>
          <input
            type="text"
            value={username}
            disabled
            className="w-full text-2xl px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 outline-none"
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Nueva Contraseña
          </label>
          <input
            type="password"
            name="newPassword"
            value={newPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Confirmar Nueva Contraseña
          </label>
          <input
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
      </div>
      <div className="space-y-4 mb-3">
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: theme?.colors?.tertiary_dark,
            color: theme?.colors?.text_login_light,
          }}
          className="w-full text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Cambiando..." : "Cambiar contraseña"}
        </button>
      </div>
    </form>
  );
}

export default ForcePasswordChangeForm;

 */

import React, { useState } from "react";
import { useConfig } from "../../contexts/config";
import { useTheme } from "../../contexts/ThemeContext";

const ForgotPasswordForm = ({ onBackToLogin, showForcePasswordChange = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const { config } = useConfig();
  const [error, setError] = useState('');
  const theme = useTheme();


  const handleForgotPassword = async (event) => {
    event.preventDefault(); // Evita que el formulario recargue la página
    
    if (!email) {
      setError('Por favor, ingresa tu dirección de correo electrónico.');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    // URL de tu endpoint. Asegúrate de que el dominio sea el correcto.
   // const apiUrl = 'https://e-aula.academia-tecnigen.cl/local/forgot_password_tipddy/restore-password.php/user/forgotpassword';
    const apiUrl = 'https://e-aula.academia-tecnigen.cl/tipddy/services/restore-password.php/user/forgotpassword'
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          // Enviamos dinámicamente la URL base de esta aplicación React
          client_url: "https://participante.academia-tecnigen.cl/" // ! window.location.origin,
        }),
      });
      console.log(response)
      const data = await response.json();

      if (response.ok && data.status === 200) {
 setMessage({ 
          type: "success", 
          text: "Hemos enviado un correo con instrucciones para recuperar tu contraseña" 
        });
        setEmail(''); // Limpiar el campo de email
      } else {
        // Usar el mensaje del backend si está disponible, o uno genérico
         setMessage({ 
          type: "error", 
          text: data.message || "No pudimos procesar tu solicitud. Verifica tu correo e intenta nuevamente." 
        });
      }
    } catch (err) {
      setMessage({ 
        type: "error", 
        text: "Ocurrió un error al procesar tu solicitud. Por favor intenta más tarde." 
      });
      console.error('Error en la solicitud de recuperación:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-[30rem] justify-between m-4">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-semibold text-zinc-200 mb-2">{showForcePasswordChange ? 'Cambia tu contraseña' : 'Recupera tu contraseña'}</h2>
        <p className="text-zinc-300 text-2xl">
          {
            showForcePasswordChange
              ? 'Por seguridad, Ingresa tu correo electrónico y te enviaremos instrucciones para que puedas definir tu nueva contraseña.'
              : 'Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.'
          }
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleForgotPassword} className="space-y-6 ">
        <div className="mb-4">
          <label htmlFor="email" className="block text-2xl font-medium text-zinc-200 mb-2">
            Correo electrónico
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ejemplo@correo.com"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-lg"
            required
            style={{
                marginBottom: ".2rem"
            }}
          />
        </div>

        {/* Message display */}
        {message.text && (
          <div className={`p-3 rounded-lg ${
            message.type === "success" ? "bg-green-600/20 text-green-200" : "bg-red-600/20 text-red-200"
          }`}>
            {message.text}
          </div>
        )}

        {/* Buttons */}
        <div className="space-y-4 pb-4" style={{
            marginBottom: ".5rem"
        }}>
          <button
            type="submit"
            disabled={loading}
            style={{
            backgroundColor: theme.colors.tertiary_dark,
            color: theme.colors.text_login_light,
          }}
            className="w-full text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                <span>Procesando...</span>
              </div>
            ) : (
              "Enviar instrucciones"
            )}
          </button>
          
        </div>
          <button
            type="button"
            onClick={onBackToLogin}
            className="w-full border border-[#44BCF9] text-[#44BCF9] hover:bg-[#44BCF9]/10 text-[16px] font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Volver al inicio de sesión
          </button>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;